import {
    InputAdornment,
    IconButton
} from "@mui/material";
import { TextInput } from "react-admin";
import ImageIcon from '@mui/icons-material/Image';
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useInput, useRecordContext } from "ra-core";
import { CommonInputProps } from "react-admin";
import { FileInputModal, FileInputModalProps } from "./FileInputModal";

export type FileInputAdornmentProps = CommonInputProps & {
    multiple?: boolean;
    fileTypes?: string[];
    path?: string;
    label?: string;
    includeDomain?: boolean;
    icon?: ReactElement;
};


export const FileInputAdornment = (props: FileInputAdornmentProps) => {
    const {
        source, 
        defaultValue,
        fileTypes=["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"],
        multiple=true,
        path = "admin/media",
        includeDomain = false, 
        icon = <ImageIcon />,
        label
    } = props;

    const { field } = useInput({ ...props, source, defaultValue });
    const record = useRecordContext();
    const [paths, setPaths] = useState<string[]>( typeof record !== 'undefined' && typeof record[source] !== 'undefined' &&  record[source] !== null ? record[source].split(", ") :  []);
    
    const fileInputModalRef = useRef<any>();


    const modalProps:FileInputModalProps =  {
        multiple:multiple,
        path: path,
        fileTypes:fileTypes,
        paths: paths,
        setPaths: setPaths,
        includeDomain: includeDomain,
    }

    const openModal = () => {
        const currentRef = fileInputModalRef.current;
        if (currentRef) {
            currentRef.handleOpen()
        }
    };

    useEffect(() => {
        field.onChange(paths.length > 0 ? paths.join(", "): "")
    }, [paths]);

    return (
        <React.Fragment>
            <FileInputModal ref={fileInputModalRef} {...modalProps}></FileInputModal>

            <TextInput 
                source={source}
                label={label ?? source}
                InputProps={{
                    endAdornment:  
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="file picker"
                            onClick={openModal}
                            edge="end"
                        >
                            {icon}
                        </IconButton>
                    </InputAdornment>
                }}
            />
        </React.Fragment>
    );
};